"use client";

import Image from "next/image";

interface ToolItem {
  key: string;
  label: string;
}
interface TrustBandProps {
  className?: string;
  compact?: boolean;
  footerText?: string;
  showIntro?: boolean;
}

export default function TrustBand({
  className = "",
  compact = false,
  footerText = "Email, calendar, docs, chat, social posts, founder communities, product analytics, and revenue events.",
  showIntro = true,
}: Readonly<TrustBandProps>) {
  const tools: ToolItem[] = [
    { key: "gmail", label: "Gmail" },
    { key: "google", label: "Google Calendar" },
    { key: "slack", label: "Slack" },
    { key: "notion", label: "Notion" },
    { key: "x", label: "X" },
    { key: "indiehackers", label: "Indie Hackers" },
    { key: "hackernews", label: "Hacker News" },
    { key: "reddit", label: "Reddit" },
    { key: "linkedin", label: "LinkedIn" },
    { key: "producthunt", label: "Product Hunt" },
    { key: "linear", label: "Linear" },
    { key: "stripe", label: "Stripe" },
    { key: "posthog", label: "PostHog" },
  ];

  return (
    <section aria-label="Integrations marquee" className={`${compact ? "py-3" : "py-6"} ${className}`}>
      <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
        {showIntro ? (
          <div className="mb-3 text-center text-sm font-medium text-foreground/60 md:mb-5">
            Signal Lucien can learn from as you connect more context
          </div>
        ) : null}
        <div className="relative overflow-hidden">
          <div
            className={`${compact ? "gap-8" : "gap-12"} flex whitespace-nowrap [animation:marquee_28s_linear_infinite] hover:[animation-play-state:paused] motion-reduce:animate-none`}
          >
            {[...tools, ...tools, ...tools].map(function render(item, i) {
              return (
                <span
                  key={`${item.key}-${i}`}
                  className="inline-flex items-center gap-2 text-foreground/85 shrink-0"
                >
                  <Image
                    src={`/trust-band/${item.key}.svg`}
                    alt={item.label}
                    width={compact ? 26 : 32}
                    height={compact ? 26 : 32}
                    className="object-contain"
                    style={{ width: "auto", height: compact ? "26px" : "32px" }}
                  />
                </span>
              );
            })}
          </div>
        </div>
        <style>{`@keyframes marquee{from{transform:translateX(0)}to{transform:translateX(-50%)}}`}</style>
        <div className={`${compact ? "mt-2 text-xs" : "mt-3 text-sm"} text-center text-muted-foreground`}>
          {footerText}
        </div>
      </div>
    </section>
  );
}
